import type { ReactNode } from 'react'
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from '@mui/material'
import { Close } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'

interface ActionDialogProps {
  open: boolean
  onClose: () => void
  title: ReactNode
  children: ReactNode
  actions: ReactNode
  pending?: boolean
}

const ActionDialog = ({
  open,
  onClose,
  title,
  children,
  actions,
  pending = false,
}: ActionDialogProps) => {
  const { t } = useTranslation()

  return (
    <Dialog
      open={open}
      onClose={pending ? undefined : onClose}
      disableEscapeKeyDown={pending}
      fullWidth
      maxWidth="xs"
    >
      <DialogTitle
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 2,
        }}
      >
        {title}

        <IconButton
          onClick={onClose}
          disabled={pending}
          aria-label={String(t('cancel'))}
          edge="end"
          sx={{ flexShrink: 0 }}
        >
          <Close />
        </IconButton>
      </DialogTitle>

      <DialogContent>{children}</DialogContent>

      <DialogActions
        disableSpacing
        sx={{
          display: 'grid',
          gridAutoFlow: 'column',
          gridAutoColumns: 'minmax(0, 1fr)',
          alignItems: 'stretch',
          gap: 1.5,
          px: 3,
          pb: 3,
          '& .MuiButton-root': {
            minWidth: 0,
            textTransform: 'none',
          },
        }}
      >
        {actions}
      </DialogActions>
    </Dialog>
  )
}

export default ActionDialog
